var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVolleyball = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26611_193169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 35C27.1648 35 34.9998 27.1651 34.9998 17.5001C34.9998 7.83521 27.1648 0.000244141 17.4999 0.000244141C7.83497 0.000244141 0 7.83521 0 17.5001C0 27.1651 7.83497 35 17.4999 35Z",
    fill: "url(#paint0_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2481 9.85707C32.5811 8.48589 31.2552 7.5409 29.7371 7.39884C27.003 7.14354 24.1797 8.06246 22.0859 10.1563C19.9166 12.3256 19.0086 15.2779 19.3607 18.1033C19.9454 18.4732 20.4992 18.9138 21.0091 19.4237C22.5718 20.9864 23.4804 22.956 23.7343 24.9915C24.0081 27.193 23.5174 29.4714 22.2609 31.3964C20.539 30.6422 18.927 29.562 17.5201 28.1545C11.4583 22.0926 11.4583 12.2302 17.5194 6.16835C19.7759 3.91188 22.5594 2.49473 25.4774 1.91895C27.062 2.73012 28.5478 3.79933 29.8744 5.1259C31.2936 6.54511 32.4184 8.14756 33.2481 9.85707Z",
    fill: "url(#paint1_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5194 28.1547C11.4579 22.0931 11.4579 12.2302 17.5194 6.16866C19.7758 3.91233 22.5589 2.49655 25.4765 1.91994C23.6634 0.991205 21.7223 0.3995 19.7461 0.14503C17.493 -0.145057 15.2238 0.612245 13.615 2.21607C13.6069 2.22409 13.5989 2.23206 13.5909 2.24009C11.5773 4.25361 10.0178 6.60272 8.95558 9.22223C7.93015 11.7509 7.41016 14.4221 7.41016 17.1616C7.41016 19.901 7.93008 22.5722 8.95558 25.101C10.0179 27.7205 11.5773 30.0696 13.5909 32.0832C14.7031 33.1954 15.918 34.1688 17.224 34.9967C20.4057 35.0465 23.5982 34.2347 26.4212 32.5596C23.163 32.121 20.0182 30.6534 17.5194 28.1547Z",
    fill: "url(#paint2_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0085 32.9385C20.1042 33.8429 19.0635 34.5284 17.9525 34.9943C13.56 35.1071 9.13292 33.5761 5.67424 30.3995C5.48839 30.2294 5.30571 30.0546 5.12577 29.8746C-1.70835 23.0405 -1.70869 11.9601 5.12535 5.12598C5.98724 4.26409 6.91639 3.51097 7.89618 2.8667C7.72763 3.01322 7.56341 3.16646 7.40316 3.32671C3.67107 7.0588 3.67107 13.1096 7.40275 16.8413C7.91265 17.3512 8.46586 17.7912 9.05036 18.1621C12.1908 20.1523 16.2385 20.1331 19.3609 18.1035L19.3613 18.1031C19.9458 18.474 20.499 18.914 21.0089 19.4239C22.5717 20.9867 23.4799 22.9557 23.7337 24.9915C24.0858 27.8168 23.1779 30.7691 21.0085 32.9385Z",
    fill: "url(#paint3_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9521 34.9943C19.0632 34.5284 20.1038 33.8428 21.0082 32.9385C23.1775 30.7692 24.0854 27.8168 23.7335 24.9914C23.4797 22.9557 22.5714 20.9867 21.0086 19.4239C20.4987 18.914 19.9452 18.4735 19.3602 18.1031C19.0078 15.2781 19.9161 12.3254 22.085 10.1565C24.1788 8.06265 27.0025 7.14345 29.7368 7.39882C31.2569 7.54081 32.5837 8.48855 33.25 9.86226C35.6389 14.7872 35.5816 20.6003 33.0782 25.4829C32.2666 27.0653 31.1988 28.5495 29.8737 29.8746C26.5717 33.1765 22.279 34.8834 17.9521 34.9943Z",
    fill: "url(#paint4_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12544 29.8742C11.9596 36.7084 23.0399 36.7084 29.874 29.8742C34.3641 25.3842 35.904 19.0612 34.4939 13.3137H0.505448C-0.9045 19.0612 0.635291 25.3842 5.12544 29.8742Z",
    fill: "url(#paint5_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0848 25.4697C33.0828 25.4745 33.0807 25.4786 33.078 25.4827C32.2668 27.0653 31.199 28.5497 29.8738 29.8749C28.7661 30.9825 27.5459 31.9103 26.2516 32.6591C24.7361 33.5358 23.1164 34.166 21.4517 34.5498C24.8831 33.7537 27.4709 30.9566 27.9783 27.4695C28.6604 22.7747 27.2 17.826 23.5951 14.2217C22.6995 13.3261 21.7215 12.5629 20.6846 11.9322C21.0709 11.3002 21.5383 10.7031 22.0853 10.1562C22.9575 9.28392 23.9567 8.61549 25.0239 8.15088C25.9057 8.7946 26.7402 9.50901 27.524 10.2927C29.5368 12.3063 31.0967 14.6561 32.1591 17.2756C32.8796 19.0523 33.3504 20.8998 33.5666 22.7918C33.6716 23.7121 33.5062 24.6455 33.0848 25.4697Z",
    fill: "url(#paint6_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9521 34.9943C19.0632 34.5284 20.1038 33.8429 21.0082 32.9385C23.1775 30.7692 24.0854 27.8169 23.7335 24.9915C23.4797 22.9557 22.5714 20.9868 21.0086 19.424C20.4987 18.9141 19.9452 18.4736 19.3602 18.1032C19.0966 15.9908 19.5377 13.8069 20.6845 11.9326C21.7212 12.5632 22.6998 13.3264 23.5952 14.2218C27.1998 17.8265 28.6608 22.7751 27.9781 27.4695C27.4699 30.9643 24.8723 33.7659 21.4301 34.5557C20.2858 34.8183 19.1203 34.9645 17.9521 34.9943Z",
    fill: "url(#paint7_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.446 18.1585C19.4173 18.14 19.389 18.1211 19.3604 18.1034L19.3608 18.103C19.389 18.1212 19.4177 18.1396 19.446 18.1585Z",
    fill: "url(#paint8_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0084 32.9385C20.104 33.8429 19.0634 34.5284 17.9524 34.9943C13.5599 35.107 9.13278 33.5761 5.6741 30.3995C5.48826 30.2294 5.30557 30.0546 5.12563 29.8746C3.75377 28.5028 2.65731 26.96 1.83626 25.3147C0.0927806 21.8215 -0.408885 17.8666 0.330094 14.1074C1.08122 16.1691 2.28295 18.1024 3.93413 19.7535C9.06834 24.8877 16.9302 25.6735 22.8988 22.1098C23.3321 23.0279 23.6103 24.0022 23.7336 24.9914C23.8577 25.9877 23.8251 26.9993 23.6358 27.9878C23.2885 29.8019 22.4129 31.534 21.0084 32.9385Z",
    fill: "url(#paint9_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8146 26.085C13.855 26.1602 13.8795 26.2455 13.8834 26.3365C13.8969 26.6584 13.6469 26.9303 13.325 26.9438C11.5109 27.02 7.84198 26.2699 5.95364 24.7143C5.70507 24.5093 5.66945 24.1418 5.8743 23.8931C6.07915 23.6445 6.44679 23.6089 6.69543 23.8138C8.27523 25.1152 11.6481 25.8465 13.276 25.7782C13.5069 25.7685 13.7121 25.8944 13.8146 26.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0084 32.9385C20.104 33.8429 19.0634 34.5284 17.9524 34.9943C13.5599 35.107 9.13278 33.5761 5.6741 30.3995C5.48826 30.2294 5.30557 30.0546 5.12563 29.8746C3.75377 28.5028 2.65731 26.96 1.83626 25.3147C0.0927806 21.8215 -0.408885 17.8666 0.330094 14.1074C1.08122 16.1691 2.28295 18.1024 3.93413 19.7535C9.06834 24.8877 16.9302 25.6735 22.8988 22.1098C23.3321 23.0279 23.6103 24.0022 23.7336 24.9914C23.8577 25.9877 23.8251 26.9993 23.6358 27.9878C23.2885 29.8019 22.4129 31.534 21.0084 32.9385Z",
    fill: "url(#paint10_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3608 18.103C19.389 18.1211 19.4177 18.1395 19.446 18.1584C19.4173 18.1399 19.389 18.1211 19.3604 18.1034L19.3608 18.103Z",
    fill: "url(#paint11_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8676 28.3173C20.3388 29.3431 17.6678 29.8628 14.9281 29.8628C12.1887 29.8624 9.51768 29.3426 6.98842 28.3173C5.1267 27.5626 3.40169 26.5565 1.83691 25.3147C2.65797 26.96 3.75443 28.5027 5.12629 29.8746C5.30623 30.0545 5.48892 30.2293 5.67476 30.3994C9.13344 33.5761 13.5605 35.107 17.953 34.9942C19.064 34.5283 20.1047 33.8428 21.0091 32.9384C22.4135 31.534 23.2892 29.8019 23.6364 27.9877C23.3827 28.1024 23.1265 28.2124 22.8676 28.3173Z",
    fill: "url(#paint12_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8676 28.3173C20.3388 29.3431 17.6678 29.8628 14.9281 29.8628C12.1887 29.8624 9.51768 29.3426 6.98842 28.3173C5.1267 27.5626 3.40169 26.5565 1.83691 25.3147C2.65797 26.96 3.75443 28.5027 5.12629 29.8746C5.30623 30.0545 5.48892 30.2293 5.67476 30.3994C9.13344 33.5761 13.5605 35.107 17.953 34.9942C19.064 34.5283 20.1047 33.8428 21.0091 32.9384C22.4135 31.534 23.2892 29.8019 23.6364 27.9877C23.3827 28.1024 23.1265 28.2124 22.8676 28.3173Z",
    fill: "url(#paint13_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3602 18.1032C19.9452 18.4736 20.4986 18.914 21.0086 19.424C22.5714 20.9868 23.4797 22.9558 23.7335 24.9915C24.0854 27.8169 23.1776 30.7693 21.0082 32.9386C20.1038 33.8429 19.0632 34.5285 17.9521 34.9944C19.1203 34.9645 20.2858 34.8183 21.43 34.5558C24.8722 33.7659 27.4699 30.9643 27.9781 27.4695C28.6608 22.7751 27.1997 17.8265 23.5951 14.2218C23.2754 13.9021 22.9446 13.5999 22.6047 13.314H19.9879C19.3685 14.8393 19.1591 16.492 19.3602 18.1032Z",
    fill: "url(#paint14_linear_26611_193169)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4031 16.2666C28.4476 16.1937 28.5089 16.1296 28.5855 16.0804C28.8566 15.9063 29.2175 15.9849 29.3916 16.256C30.3727 17.7838 31.5763 21.33 31.186 23.7452C31.1344 24.0632 30.8351 24.2794 30.5171 24.2279C30.199 24.1765 29.9829 23.8771 30.0343 23.559C30.3608 21.5384 29.2903 18.2573 28.41 16.8863C28.2851 16.692 28.2902 16.4513 28.4031 16.2666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5955 14.2217C27.2005 17.826 28.6609 22.7747 27.9787 27.4695C27.4713 30.9566 24.8836 33.7538 21.4521 34.5498C23.1169 34.166 24.7364 33.5358 26.2521 32.6591C27.5464 31.9104 28.7666 30.9825 29.8742 29.8749C31.1994 28.5497 32.2673 27.0653 33.0784 25.4827C33.0812 25.4786 33.0832 25.4745 33.0853 25.4697C33.5067 24.6455 33.6721 23.7121 33.5671 22.7918C33.3509 20.8998 32.8801 19.0523 32.1595 17.2756C31.5911 15.8741 30.8789 14.5506 30.0326 13.3137H22.6053C22.9451 13.5997 23.2758 13.9019 23.5955 14.2217Z",
    fill: "url(#paint15_linear_26611_193169)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26611_193169",
    x1: 9.01639,
    y1: 3.36092,
    x2: 13.3399,
    y2: 10.5668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26611_193169",
    x1: 14.9552,
    y1: 7.8981,
    x2: 25.1469,
    y2: 18.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0593FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1888,
    stopColor: "#088BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4804,
    stopColor: "#1176E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#1F53C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2740B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26611_193169",
    x1: 10.5744,
    y1: 6.93248,
    x2: 18.6724,
    y2: 16.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26611_193169",
    x1: 10.1269,
    y1: 18.6877,
    x2: 12.872,
    y2: 24.8642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26611_193169",
    x1: 12.8067,
    y1: 3.93554,
    x2: 23.993,
    y2: 20.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26611_193169",
    x1: 17.4997,
    y1: 17.2941,
    x2: 17.4997,
    y2: 28.0904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1607,
    stopColor: "#78A7D7",
    stopOpacity: 0.161
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4059,
    stopColor: "#729AC2",
    stopOpacity: 0.406
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7031,
    stopColor: "#6686A0",
    stopOpacity: 0.703
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#596C76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26611_193169",
    x1: 20.9007,
    y1: 18.8342,
    x2: 28.3753,
    y2: 26.3087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0593FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1888,
    stopColor: "#088BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4804,
    stopColor: "#1176E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#1F53C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2740B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26611_193169",
    x1: 17.5042,
    y1: 21.3387,
    x2: 25.589,
    y2: 29.4235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26611_193169",
    x1: 19.3678,
    y1: 18.092,
    x2: 19.4381,
    y2: 18.1623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1976,
    stopColor: "#FD9237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4334,
    stopColor: "#FA8433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6888,
    stopColor: "#F66C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9564,
    stopColor: "#F04A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26611_193169",
    x1: 11.9037,
    y1: 22.3726,
    x2: 11.9037,
    y2: 30.6424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_26611_193169",
    x1: 13.557,
    y1: 25.5108,
    x2: 19.7335,
    y2: 32.1677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_26611_193169",
    x1: 19.3678,
    y1: 18.0919,
    x2: 19.4381,
    y2: 18.1623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_26611_193169",
    x1: 12.7367,
    y1: 26.8334,
    x2: 12.7367,
    y2: 34.3852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0593FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1888,
    stopColor: "#088BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4804,
    stopColor: "#1176E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#1F53C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2740B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_26611_193169",
    x1: 12.7367,
    y1: 21.6177,
    x2: 12.7367,
    y2: 32.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3969,
    stopColor: "#1E3391",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    stopColor: "#1A2C82",
    stopOpacity: 0.872
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_26611_193169",
    x1: 19.8436,
    y1: 20.3323,
    x2: 24.4416,
    y2: 32.2734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_26611_193169",
    x1: 25.1499,
    y1: 19.4481,
    x2: 27.3459,
    y2: 27.6148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3596",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3969,
    stopColor: "#1E3391",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    stopColor: "#1A2C82",
    stopOpacity: 0.872
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192A7D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26611_193169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVolleyball);
export default ForwardRef;